import { Component, OnInit } from '@angular/core';
import { SessionService } from '../Services/session.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-session-ended',
    templateUrl: './session-ended.component.html',
    styleUrls: ['./session-ended.component.scss'],
    standalone: false
})
export class SessionEndedComponent implements OnInit {

  readonly startPath = '/' + environment.startRoute[0];
  returnToPage: string = $localize`Return to the welcome page.`;

  constructor(private readonly sessionService: SessionService) { }

  ngOnInit(): void {
    if(this.sessionService.partiallyDeletedCookies() || this.sessionService.activeSessionCheck()) {
      this.sessionService.endSession();
    } else {
      this.sessionService.killSession();
    }
    switch(environment.startRoute[0]){
      case 'welcome':
        this.returnToPage = $localize`Return to the welcome page.`;
        break;
      case 'registration':
        this.returnToPage = $localize`Return to the registration page.`;
        break;
      case 'home':
        this.returnToPage = $localize`Return to the verification page.`;
        break;
      default:
        this.returnToPage = $localize`Return to the welcome page.`;
        break;
    }
  }

}
